import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAllInstalmentService } from "../../Api/HeyTraderService/PaymentApiService";
import { mapPayment } from "../Types/SiteMenuModel/Payment/Instalment";

// get all payment thunks.
export const getAllPaymentInstalment = createAsyncThunk('getAllPaymentInstalment', async (_, { rejectWithValue }) => {
  try {
    // api
    const response = await getAllInstalmentService();
    if (response.status) {
      return mapPayment(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});
